import axios from "axios";
import logout from "./logout";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    // console.log(" Error MESSAGE", error);

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      logout();

      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

export default apiClient;
